export const images = {
  logo: "https://cdn.magicpatterns.com/uploads/gXr61xas936YxUY9Zes85V/logomcn.png",
  hero: "https://cdn.magicpatterns.com/patterns/generated-images/f01470aa-3751-4abd-9ba8-51aa165195f1.jpg",
  mirror: "https://cdn.magicpatterns.com/patterns/generated-images/30fdbbab-235f-4423-ba2c-a3b3c5ee976a.jpg",
  nightDinner: "https://cdn.magicpatterns.com/patterns/generated-images/a71ae029-0c95-4b60-9781-587b09ee7129.jpg",
  plates: "https://cdn.magicpatterns.com/patterns/generated-images/4e507f06-7baf-4665-b708-b5d99cfe2f9f.jpg",
  dinner: "https://cdn.magicpatterns.com/patterns/generated-images/10271d8d-aeb8-4ea0-ac1e-71d67d665ec3.jpg",
  product: "https://cdn.magicpatterns.com/uploads/uQDMNsa97XUV8hk1pDKGvz/portadacenas.png",
};

export const links = {
  checkout: "https://pay.hotmart.com/F104765975P?checkoutMode=10",
};
